import { useEffect } from 'react';

import { useConfig } from '@cloud-ui/contexts/ConfigContext';

import { useLocation } from 'react-router-dom';

import { getPostHogClient } from './posthogClient';

export default function PostHogPageView() {
  const location = useLocation();
  const { browserTelemetryReady, disableTelemetry } = useConfig();

  // Track pageviews
  useEffect(() => {
    if (!browserTelemetryReady || disableTelemetry) {
      return;
    }

    const posthogClient = getPostHogClient();

    if (posthogClient) {
      posthogClient.capture('$pageview', {
        $current_url: window.location.href,
      });
    }
  }, [browserTelemetryReady, disableTelemetry, location]);

  return null;
}
